import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type {
  BankList,
  PayoutAccount,
  PayoutAccountBody,
  PayoutAccountList,
  StoreAccountList,
} from '../types/bank.types';

export const fetchBanks = async (): Promise<BankList> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.banks}`);
};

/** Pembayaran: the store's accounts the customer may transfer to. */
export const fetchStoreAccounts = async (): Promise<StoreAccountList> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.storeAccounts}`);
};

/** 403 for a Member, 404 without an affiliate account. */
export const fetchPayoutAccounts = async (): Promise<PayoutAccountList> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.payoutAccounts}`);
};

/** Checked with DOKU's account inquiry first: an unknown account is a 400 on `account_number`. */
export const createPayoutAccount = async (body: PayoutAccountBody): Promise<PayoutAccount> => {
  return await request.post(`${URLS.BACK_DSH}${APIS.payoutAccounts}`, body);
};
